import { render, staticRenderFns } from "./PendingInvoices.vue?vue&type=template&id=740a0620&"
import script from "./PendingInvoices.vue?vue&type=script&lang=js&"
export * from "./PendingInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports